import { usePartnership } from '@round/creatorbase-helpers/api-hooks';
import { Image } from '@round/ui-kit';
import { Badge } from '@round/whitelabel-ui';
import cn from 'classnames';
import Skeleton from 'react-loading-skeleton';
import styles from './AgencyBadge.module.css';

type Props = {
    partnershipId: number;
    className?: string;
};

const AgencyBadge = ({ partnershipId, className }: Props) => {
    const { data: partnership, isLoading } = usePartnership(partnershipId);

    if (isLoading) {
        return <Skeleton width="4rem" height="1rem" />;
    }

    if (!partnership) {
        return null;
    }

    return (
        <Badge className={cn(styles.badge, className)}>
            <span className={styles.logoContainer}>
                <Image className={styles.logo} src={partnership.agency_logo ?? ''} alt={partnership.agency_name} />
            </span>
            <span>{partnership.agency_name}</span>
        </Badge>
    );
};

export default AgencyBadge;
